import React from "react";
import { observer } from "mobx-react";
import { Cubby } from "../../stores/Cubby";
import {
  IconAlertTriangle,
  IconPlayerStop,
  IconCircleDashedCheck,
} from "@tabler/icons-react";
import StatusDisplayUnit from "./statusDisplayUnit";

interface RunningStatusProps {
  cubby: Cubby;
}

// Helper function to get status content
const getStatusContent = (status: string, cubby: Cubby) => {
  switch (status) {
    case "not_yet_initialized":
    case "initialize_in_progress":
    case "initialized":
    case "starting_up":
    case "started_successfully":
    case "wallet_info_available":
      return {
        useLoader: true,
        color: "blue",
        text: "STARTING",
      };

    case "subscriptions_started":
      if (!cubby.allowOnchainActions) {
        return {
          useLoader: true,
          color: "blue",
          text: "SYNCING",
        };
      } else if (!cubby.isConsideredReadyForBasicLightningApiRequests) {
        return {
          useLoader: true,
          color: "blue",
          text: "SYNCING",
        };
      } else {
        return {
          icon: <IconCircleDashedCheck size={24} />,
          color: "white",
          text: "RUNNING",
        };
      }

    case "shutting_down":
    case "force_stop_in_progress":
      return {
        useLoader: true,
        color: "orange",
        text: "STOPPING",
      };

    case "stopped":
      return {
        icon: <IconPlayerStop size={24} />,
        color: "white",
        text: "STOPPED",
      };

    case "evacuation_in_progress":
    case "evacuation_restore_in_progress":
    case "initialize_for_recovery_in_progress":
    case "deleted_by_user":
    case "deleted_from_fortress":
      return {
        icon: <IconAlertTriangle size={24} />,
        color: "red",
        text: "Contact support",
      };

    default:
      return {
        icon: <IconAlertTriangle size={24} />,
        color: "gray",
        text: "Unknown status",
      };
  }
};

const RunningStatus = observer(({ cubby }: RunningStatusProps) => {
  const { icon, useLoader, color, text } = getStatusContent(
    cubby.runStatus,
    cubby
  );

  return (
    <StatusDisplayUnit
      text={text}
      statusDetail="status"
      useLoader={useLoader}
      icon={icon}
      color={color}
      cubby={cubby}
    />
  );
});

export default RunningStatus;
